import React, { useEffect, useState } from 'react'
import { Button, Image, Table } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../../components/Loader'
import SearchBox from '../../../components/Searchbox'
import CustomToast from '../../../components/Toast/CustomToast'
import axiosProvider from '../../../lib/AxiosProvider'
import useDebounce from '../../../lib/useDebounce'
import ManageBannerModel from './ManageBannerModel'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { _SwalDelete } from '../../../lib/exceptionMessage'
import { _headerMenuImg_ } from '../../../lib/ImagePath'
import PlusIcon from '../../../components/AllSvgIcon/PlusIcon'
import EditIcon from '../../../components/AllSvgIcon/EditIcon'
import DeleteIcon from '../../../components/AllSvgIcon/DeleteIcon'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'
import Previewicon from '../../../components/AllSvgIcon/Previewicon'
import { useImmer } from 'use-immer'
import { encodeId, encodedSearchText } from '../../../lib/AllGlobalFunction'

const ManageMenu = () => {
  const navigate = useNavigate()
  const [modalShow, setModalShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [data, setData] = useState()
  const [editData, setEditData] = useState()
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const { userId } = useSelector((state) => state?.user?.userInfo)
  const location = useLocation()
  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 0,
    pageIndex: 0,
    searchText: ''
  })
  const debounceSearchText = useDebounce(searchText, 500)
  const { pageAccess } = useSelector((state) => state.user)

  useEffect(() => {
    if (debounceSearchText) {
      setFilterDetails((draft) => {
        draft.searchText = debounceSearchText
        draft.pageIndex = 0
      })
    } else {
      setFilterDetails((draft) => {
        draft.searchText = ''
        draft.pageIndex = 0
      })
    }
  }, [debounceSearchText])

  const fetchData = async () => {
    try {
      setLoading(true)

      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'ManageHeaderMenu/search',
        queryString: `?searchText=${encodedSearchText(
          filterDetails?.searchText
        )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
          filterDetails?.pageSize
        }`
      })
      setLoading(false)
      if (response?.status === 200) {
        setData({
          ...response,
          data: {
            ...response?.data,
            pagination: {
              ...response?.data?.pagination,
              recordCount: response?.data?.pagination?.recordCount
                ? response?.data?.pagination?.recordCount
                : 0
            }
          }
        })
      }
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!modalShow) {
      fetchData()
    }
  }, [filterDetails])

  const handleEditData = async (id) => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'ManageHeaderMenu/byId',
      queryString: `?id=${id}`
    })
      .then((res) => {
        if (res?.status === 200) {
          setEditData(res.data.data)
          setModalShow(true)
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const handleDelete = async (id) => {
    const response = await axiosProvider({
      method: 'DELETE',
      endpoint: `ManageHeaderMenu?id=${id}`,
      userId,
      location: location.pathname
    })
      .then((res) => {
        if (res?.status === 200) {
          fetchData()
          setEditData()
        }
        setToast({
          show: true,
          text: res?.data?.message,
          variation: res?.data?.code !== 200 ? 'error' : 'success'
        })

        setTimeout(() => {
          setToast({ ...toast, show: false })
        }, 2000)
      })
      .catch((err) => {})
  }

  return checkPageAccess(
    pageAccess,
    allPages?.manageMenu,
    allCrudNames?.read
  ) ? (
    <>
      <div className='d-flex align-items-center mb-3 gap-3 flex-row-reverse'>
        {checkPageAccess(
          pageAccess,
          allPages?.manageMenu,
          allCrudNames?.write
        ) && data?.data?.pagination?.recordCount ? (
          data?.data?.pagination?.recordCount < 6 && (
            <Button
              variant='warning'
              className='d-flex align-items-center gap-2 fw-semibold btn btn-warning ms-auto'
              onClick={() => setModalShow(true)}
            >
              <i className='m-icon m-icon--plusblack'></i>
              Create
            </Button>
          )
        ) : (
          <Button
            variant='warning'
            className='d-flex align-items-center gap-2 fw-semibold btn btn-warning ms-auto'
            onClick={() => setModalShow(true)}
          >
            <i className='m-icon m-icon--plusblack'></i>
            Create
          </Button>
        )}

        <SearchBox
          placeholderText={'Search'}
          value={searchText}
          searchclassnamewrapper={'searchbox-wrapper me-auto'}
          onChange={(e) => {
            setSearchText(e?.target?.value)
          }}
        />
      </div>

      {loading && !modalShow && <Loader />}

      <Table responsive className='align-middle table-list'>
        <thead className='align-middle'>
          <tr>
            <th>Title</th>
            <th>Redirect to</th>
            <th>Sequence</th>
            {checkPageAccess(pageAccess, allPages?.manageMenu, [
              allCrudNames?.update,
              allCrudNames?.delete,
              allCrudNames?.write,
              allCrudNames?.read
            ]) && <th className='text-center'>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data?.data?.data?.length > 0 ? (
            data?.data?.data?.map((data) => (
              <tr key={Math.floor(Math.random() * 1000000)}>
                <td>
                  <div className='d-flex gap-2 align-items-center'>
                    <Image
                      src={
                        data?.image
                          ? `${process.env.REACT_APP_IMG_URL}${_headerMenuImg_}${data?.image}`
                          : 'https://placehold.jp/50x50.png'
                      }
                      className='img-thumbnail table-img-box'
                    />
                    <span>{data.name}</span>
                  </div>
                </td>
                <td>{data?.redirectTo}</td>
                <td>{data?.sequence}</td>
                <td>
                  <div className='d-flex align-items-center gap-2 justify-content-center'>
                    {checkPageAccess(
                      pageAccess,
                      allPages?.manageMenu,
                      allCrudNames?.read
                    ) && (
                      <span
                        onClick={() => {
                          navigate(
                            `/settings/manage-sub-menu?id=${encodeId(
                              data?.id
                            )}&name=${data?.name}`
                          )
                        }}
                        className='d-flex justify-content-center align-items-center'
                      >
                        <Previewicon bg={'bg'} />
                      </span>
                    )}
                    {checkPageAccess(
                      pageAccess,
                      allPages?.manageMenu,
                      allCrudNames?.write
                    ) && (
                      <span
                        onClick={() => {
                          navigate(
                            `/settings/manage-sub-menu?id=${encodeId(
                              data?.id
                            )}&name=${data?.name}`
                          )
                        }}
                        className='d-flex justify-content-center align-items-center'
                      >
                        <PlusIcon bg={'bg'} />
                      </span>
                    )}
                    {checkPageAccess(
                      pageAccess,
                      allPages?.manageMenu,
                      allCrudNames?.update
                    ) && (
                      <span
                        onClick={() => {
                          handleEditData(data?.id)
                        }}
                        style={{
                          backgroundColor: 'var(--bg-default)',
                          borderRadius: '0.375rem'
                        }}
                        className='d-flex justify-content-center align-items-center'
                      >
                        <EditIcon bg={'bg'} />
                      </span>
                    )}
                    {checkPageAccess(
                      pageAccess,
                      allPages?.manageMenu,
                      allCrudNames?.delete
                    ) && (
                      <span
                        onClick={() => {
                          Swal.fire({
                            title: _SwalDelete.title,
                            text: _SwalDelete.text,
                            icon: _SwalDelete.icon,
                            showCancelButton: _SwalDelete.showCancelButton,
                            confirmButtonColor: _SwalDelete.confirmButtonColor,
                            cancelButtonColor: _SwalDelete.cancelButtonColor,
                            confirmButtonText: _SwalDelete.confirmButtonText,
                            cancelButtonText: _SwalDelete.cancelButtonText
                          }).then((result) => {
                            if (result.isConfirmed) {
                              handleDelete(data?.id)
                            } else if (result.isDenied) {
                            }
                          })
                        }}
                      >
                        <DeleteIcon bg={'bg'} />
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className='text-center'>
                {data?.data?.message}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {modalShow && (
        <ManageBannerModel
          fetchData={fetchData}
          modalShow={modalShow}
          setModalShow={setModalShow}
          editData={editData}
          setEditData={setEditData}
          setToast={setToast}
          toast={toast}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </>
  ) : (
    <NotFound />
  )
}

export default ManageMenu
